"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skill = void 0;
var SkillVersion_1 = require("./SkillVersion");
/**
 * Represents Skill information
 */
var Skill = /** @class */ (function (_super) {
    __extends(Skill, _super);
    function Skill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Skill";
        /**
         * Id of the tenant
         */
        _this.tenantId = function () {
            _this.push(function (_) { return "tenantId"; });
        };
        /**
         * Skill reference
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * The name of the skill
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * Detailed description about the skill
         */
        _this.appendent = function () {
            _this.push(function (_) { return "appendent"; });
        };
        /**
         * The list of labels of the skill
         */
        _this.labelList = function () {
            _this.push(function (_) { return "labelList"; });
        };
        /**
         * The uri of the repository where the skill is
         */
        _this.repositoryUri = function () {
            _this.push(function (_) { return "repositoryUri"; });
        };
        /**
         * The type of the repository where the skill is
         */
        _this.repositoryType = function () {
            _this.push(function (_) { return "repositoryType"; });
        };
        /**
         * The list of available and build skill versions
         */
        _this.versions = function (config) { return _this.push(function (registry) {
            var entity = new SkillVersion_1.SkillVersion();
            config(entity);
            return "versions { " + entity.render(registry) + " }";
        }); };
        /**
         * A list of all available version tags
         */
        _this.tags = function () {
            _this.push(function (_) { return "tags"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Skill;
}(Array));
exports.Skill = Skill;
//# sourceMappingURL=Skill.js.map